import { render, staticRenderFns } from "./FeeguidancePage.vue?vue&type=template&id=27739fab&scoped=true&"
import script from "./FeeguidancePage.vue?vue&type=script&lang=js&"
export * from "./FeeguidancePage.vue?vue&type=script&lang=js&"
import style0 from "./FeeguidancePage.vue?vue&type=style&index=0&id=27739fab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27739fab",
  null
  
)

/* custom blocks */
import block0 from "./FeeguidancePage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports